import React from 'react';

import Ads from './ad/Ads';
import JobAds from './ad2/Ads'

type AdsAdapterProps = {
    useFabric: boolean,
} & React.ComponentProps<typeof Ads>

const AdsAdapter = (props: AdsAdapterProps) => {
    const {
        useFabric,
        ...passThroughProps
    } = props;

    if (useFabric) {
        return (
            <JobAds
                {...passThroughProps}
            />
        )
    }

    return(
        <Ads
            {...passThroughProps}
        />
    )
}

export default AdsAdapter;